import { mapGetters, mapActions } from 'vuex'
import { GETTERS, ACTIONS } from '@/store/constants'
import distanceWeight from '@turf/distance-weight'
import setLocation from './setLocation'
import { SECURITY_CONTROLS, PUBLIC_TRANSPORT, ONEWAY } from '@/utils/routing-actions'

export default {
  mixins: [setLocation],
  computed: {
    ...mapGetters({
      routeC: GETTERS.GET_ROUTE,
      originC: GETTERS.GET_ORIGIN,
      destinationC: GETTERS.GET_DESTINATION,
      newPoints: GETTERS.GET_NEW_POINT,
      pmrProfile: GETTERS.GET_PMR_PROFILE
    }),
    steps: {
      get () {
        return this.routeC.steps
      },
      set (value) {
        this[ACTIONS.MOVE_ROUTE]({ steps: value })
      }
    },
    route () {
      return this.routeC.route
    },
    origin () {
      const el = this.originC
      if (el) {
        this.setLocation([el])
        return el
      }
    },
    destination () {
      const el = this.destinationC
      if (el) {
        this.setLocation([el])
        return el
      }
    },
    duration () {
      return this.routeC.duration
    },
    distance () {
      return this.routeC.distance
    },
    error () {
      return this.routeC.error
    },
    loading () {
      return this.routeC.loading
    },
    destinationName () {
      return this.routeC.destinationName
    },
    routeCondition () {
      let msg = ''
      let msg2 = ''
      let msg3 = ''
      let hasSecurityControl
      let hasSecuritiesControl
      let hasPassportControl
      let hasTrain
      let hasBus
      let hasOneWay
      let icon = this.pmrProfile === null ? 'hombre-caminando-t.svg' : 'pmr-t-green.svg'

      this.route.some(route => {
        const ind = route.instructions.filter(i => {
          return SECURITY_CONTROLS.includes(i.tag.type.toUpperCase()) || PUBLIC_TRANSPORT.includes(i.tag.type.toUpperCase()) || ONEWAY.includes(i.tag.type.toUpperCase())
        })

        hasSecurityControl = ind.filter(x => x.tag.type.toUpperCase() === SECURITY_CONTROLS[0]).length
        hasPassportControl = ind.filter(x => x.tag.type.toUpperCase() === SECURITY_CONTROLS[1]).length
        hasOneWay = ind.filter(x => x.tag.type.toUpperCase() === ONEWAY[0]).length
        hasSecuritiesControl = hasSecurityControl > 1 || (hasSecurityControl && hasPassportControl)
        hasTrain = ind.filter(x => x.tag.type.toUpperCase() === PUBLIC_TRANSPORT[0]).length
        hasBus = ind.filter(x => x.tag.type.toUpperCase() === PUBLIC_TRANSPORT[1]).length
        return hasSecurityControl ||
        hasSecuritiesControl ||
        hasPassportControl ||
        hasTrain ||
        hasBus
      })

      if (hasSecuritiesControl) {
        msg = 'ROUTE_SECURITY_CONTROL_PLUS'
        icon = 'icon-seguridad-t.svg'
      } else if (hasSecurityControl) {
        msg = 'ROUTE_SECURITY_CONTROL'
        icon = 'icon-seguridad-t.svg'
      } else if (hasPassportControl) {
        msg = 'ROUTE_PASSPORT_CONTROL'
        icon = 'cruza-el-control-de-pasaporte-jj.svg'
      }

      if (hasTrain && hasBus) {
        msg2 = 'ROUTE_MULTI_TRANSPORT'
        icon = 'transporte-publico-t.svg'
      } else if (hasTrain) {
        msg2 = 'ROUTE_TRAIN'
        icon = 'metro-t.svg'
      } else if (hasBus) {
        msg2 = 'ROUTE_BUS'
        icon = 'bus-grande-t.svg'
      }

      if (hasOneWay) {
        msg3 = 'ROUTE_ONEWAY_NO_RETURN'
        // icon = 'pasillo_sin_retorno.svg'
      }

      if (!msg && !msg2) {
        msg2 = this.pmrProfile === null ? 'ROUTE_NORMAL' : 'ROUTE_NORMAL_PMR'
      }

      if (msg && msg2) {
        icon = 'seguridad-transporte.svg'
      }

      return {
        msg,
        msg2,
        msg3,
        icon,
        securityControl: !!hasSecurityControl || !!hasPassportControl,
        oneWay: !!hasOneWay
      }
    },
    iconCondition () {
      return this.routeCondition.icon
    },
    z () {
      return this.routeC.z
    }
  },
  methods: {
    ...mapActions([
      ACTIONS.LOAD_ROUTE,
      ACTIONS.CLEAR_ROUTE,
      ACTIONS.MOVE_ROUTE,
      ACTIONS.SET_DESTINATION_NAME
    ]),
    moreClose (points) {
      let point = points[0]
      if (this.origin || this.destination) {
        const features = {
          type: 'FeatureCollection',
          features: [
            this.origin || this.destination,
            ...points
          ]
        }
        const distances = distanceWeight(features)
        const distance = distances[0]
        distance.shift()
        const min = Math.max(...distance)
        const index = distance.findIndex(x => x === min)
        point = points[index]
      }

      return point
    },
    setDestination (destination) {
      this[ACTIONS.SET_DESTINATION_NAME](destination)
    }
  }
}
